
export class SafetyPanel {
  constructor() {
    // 甲板左系统电源
    this.deckLeftSysPower = false
    // 甲板左开关状态 
    // lock/lockOn/close/open
    this.deckLeftSwitchStatus = 'lock'
    // 甲板右系统电源
    this.deckRightSysPower = false
    // 甲板右开关状态 
    // lock/lockOn/close/open
    this.deckRightSwitchStatus = 'lock'

    // 倒计时point
    this.point = 300,
    // 左系统倒计时
    this.leftCountDown = this.point,
    // 右系统倒计时
    this.rightCountDown = this.point,
    // 是否报警
    this.deskAlarmLeft = false,
    this.deskAlarmRight = false
  }
}